import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.modal');
import { HostListener, Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-modal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.modal/view.scss */
/* src/app/portal.season.modal/view.scss: no such file or directory */`],
})
export class PortalSeasonModalComponent implements OnInit {
    @Input() model: any = null;

    constructor(@Inject( Service) public service: Service) {
        if (!this.model) this.model = service.modal;
    }

    public async ngOnInit() {
    }

    @HostListener('document:keydown.escape', ['$event'])
    public async closeOnEscape(event: KeyboardEvent) {
        if (!this.model?.isshow) return;

        event.preventDefault();
        if (this.model.opts?.cancel) {
            await this.model.cancel();
            return;
        }

        await this.model.hide();
    }

    public modalTitle() {
        if (this.model.opts?.title) return this.model.opts.title;

        if (this.model.opts?.status == 'error') return '처리하지 못했습니다';
        if (this.model.opts?.status == 'warning') return '확인이 필요합니다';
        if (this.model.opts?.status == 'success') return '처리가 완료되었습니다';
        return '알림';
    }

    public statusLabel() {
        if (this.model.opts?.status == 'error') return '오류';
        if (this.model.opts?.status == 'warning') return '주의';
        if (this.model.opts?.status == 'success') return '완료';
        return '안내';
    }

    public actionLabel() {
        const label = this.model.opts?.action;
        if (typeof label == 'string' && label.trim()) return label;
        return '확인';
    }

    public cancelLabel() {
        const label = this.model.opts?.cancel;
        if (typeof label == 'string' && label.trim()) return label;
        return '취소';
    }

    public iconContainerClass() {
        if (this.model.opts?.status == 'error')
            return 'bg-rose-50 ring-rose-100';
        if (this.model.opts?.status == 'warning')
            return 'bg-amber-50 ring-amber-100';
        if (this.model.opts?.status == 'success')
            return 'bg-emerald-50 ring-emerald-100';
        return 'bg-slate-100 ring-slate-200';
    }

    public statusTextClass() {
        if (this.model.opts?.status == 'error') return 'text-rose-600';
        if (this.model.opts?.status == 'warning') return 'text-amber-700';
        if (this.model.opts?.status == 'success') return 'text-emerald-700';
        return 'text-slate-500';
    }

    public btnColorClass() {
        const base = 'inline-flex min-h-10 w-full items-center justify-center rounded-lg px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition focus:outline-none focus:ring-2 focus:ring-offset-2 sm:w-auto sm:min-w-24';

        if (this.model.opts?.status == 'warning')
            return `${base} bg-amber-600 hover:bg-amber-500 focus:ring-amber-500`;
        if (this.model.opts?.status == 'success')
            return `${base} bg-emerald-700 hover:bg-emerald-600 focus:ring-emerald-600`;
        if (this.model.opts?.status == 'error')
            return `${base} bg-rose-600 hover:bg-rose-500 focus:ring-rose-500`;
        return `${base} bg-slate-900 hover:bg-slate-800 focus:ring-slate-700`;
    }
}

export default PortalSeasonModalComponent;